<template>
	<div class="flex flex-col w-full h-40 items-center justify-center mt-8">
		<h1 class="text-4xl md:text-6xl font-serif!">
			B & G
		</h1>
		<Divider class="w-40! md:w-60!" />
		<h2 class="text-lg md:text-2xl font-light tracking-widest">
			05.29.2027
		</h2>
	</div>
</template>

<script setup lang="ts">
	const { formatDate } = useUtils();
</script>

<style scoped>

</style>